import {
  useAppUrlParams,
  UrlParamName,
} from './useAppUrlParams';

export function useIssueRouteParams(): {
  projectId: string;
  issueId: string;
} {
  const projectId = useAppUrlParams(UrlParamName.PROJECT_ID);
  const issueId = useAppUrlParams(UrlParamName.ISSUE_ID);
  return { projectId, issueId };
}

export function useIssueEventRouteParams(): {
  projectId: string;
  issueId: string;
  eventId: string;
} {
  const projectId = useAppUrlParams(UrlParamName.PROJECT_ID);
  const issueId = useAppUrlParams(UrlParamName.ISSUE_ID);
  const eventId = useAppUrlParams(UrlParamName.EVENT_ID);
  return { projectId, issueId, eventId };
}

export function useIssueDecisionRouteParams(): {
  projectId: string;
  issueId: string;
  decisionId: string | undefined;
} {
  const projectId = useAppUrlParams(UrlParamName.PROJECT_ID);
  const issueId = useAppUrlParams(UrlParamName.ISSUE_ID);
  const decisionId = useAppUrlParams(UrlParamName.DECISION_ID);
  return { projectId, issueId, decisionId };
}

export function useIssueDocumentRouteParams(): {
  projectId: string;
  issueId: string;
  eventId: string | undefined;
  documentId: string | undefined;
  linkedDocumentationVersionId: string | undefined;
} {
  const projectId = useAppUrlParams(UrlParamName.PROJECT_ID);
  const issueId = useAppUrlParams(UrlParamName.ISSUE_ID);
  const eventId = useAppUrlParams(UrlParamName.EVENT_ID);
  const documentId = useAppUrlParams(UrlParamName.DOCUMENT_ID);
  const linkedDocumentationVersionId = useAppUrlParams(
    UrlParamName.LINKED_DOCUMENTATION_VERSION_ID
  );
  return {
    projectId,
    issueId,
    eventId,
    documentId,
    linkedDocumentationVersionId,
  };
}

export function useResourceDownloadRouteParams(): {
  reportId: string;
  documentId: string;
  issueId: string;
  eventId: string;
  incomingEmailMessageId: string;
  linkedDocumentationId: string;
} {
  const reportId = useAppUrlParams(UrlParamName.REPORT_ID);
  const documentId = useAppUrlParams(UrlParamName.DOCUMENT_ID);
  const issueId = useAppUrlParams(UrlParamName.ISSUE_ID);
  const eventId = useAppUrlParams(UrlParamName.EVENT_ID);
  const incomingEmailMessageId = useAppUrlParams(UrlParamName.INCOMING_EMAIL_MESSAGE_ID);
  const linkedDocumentationId = useAppUrlParams(UrlParamName.LINKED_DOCUMENTATION_ID);
  return { reportId, documentId, issueId, eventId, incomingEmailMessageId, linkedDocumentationId };
}
